import { useLottery } from '@/providers/BlockPotProvider'
import { useEffect, useState } from 'react'

export default function useLoadedGameRounds() {
    const [loadedRoundIndexes, setLoadedRoundIndexes] = useState<number[]>([])
    const lottery = useLottery()

    const canLoadNewerRound = !(loadedRoundIndexes.length == 0 || loadedRoundIndexes[0] == lottery.roundIndex - 1)
    const canLoadOlderRound = !(loadedRoundIndexes.length == 0 || loadedRoundIndexes[loadedRoundIndexes.length - 1] == 0)

    const loadOlderRound = () => {
        setLoadedRoundIndexes((currentLoadedRoundIndexes: number[]) => {
            if (!canLoadOlderRound) {
                return currentLoadedRoundIndexes
            }
            return [...(currentLoadedRoundIndexes.slice(1, 4)), currentLoadedRoundIndexes[currentLoadedRoundIndexes.length - 1] - 1]
        })
    }

    const loadNewerRound = () => {
        setLoadedRoundIndexes((currentLoadedRoundIndexes: number[]) => {
            if (!canLoadNewerRound) {
                return currentLoadedRoundIndexes
            }
            return [currentLoadedRoundIndexes[0] + 1, ...(currentLoadedRoundIndexes.slice(0, 3))]
        })
    }

    const resetLoadedRoundIndexes = () => {
        setLoadedRoundIndexes([])
    }

    useEffect(() => {
        if (lottery.roundIndex > 0) {
            if (loadedRoundIndexes.length == 0) {
                const rounds: number[] = []
                let index = lottery.roundIndex - 1
                while (index >= 0 && rounds.length < 4) {
                    rounds.push(index)
                    index -= 1
                }
                setLoadedRoundIndexes(rounds)
            }
        }
    }, [loadedRoundIndexes, lottery.roundIndex])

    return {
        loadedRoundIndexes,
        resetLoadedRoundIndexes,
        loadOlderRound,
        loadNewerRound,
        canLoadNewerRound,
        canLoadOlderRound
    }
}

export type UseLoadedGameRoundsReturnType = ReturnType<typeof useLoadedGameRounds>